module.exports = __webpack_public_path__ + "img/shipo-icon-double-arrow-right.b4cd2542.svg";